module.exports = __webpack_public_path__ + "static/media/climate_chang.3b5284c9.jpeg";